import { Component, ChangeDetectionStrategy, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { ContextualHelpService } from '../../../core/services/contextual-help.service';

@Component({
  selector: 'app-help-fab',
  imports: [CommonModule, MatIconModule],
  templateUrl: './help-fab.component.html',
  styleUrl: './help-fab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpFabComponent {
  private readonly router = inject(Router);
  private readonly helpService = inject(ContextualHelpService);

  readonly guide = this.helpService.activeGuide;
  readonly isOpen = this.helpService.isOpen;

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isOpen()) {
      this.helpService.close();
    }
  }

  toggle(): void {
    this.helpService.toggle();
  }

  close(): void {
    this.helpService.close();
  }

  goTo(route: string): void {
    this.helpService.close();
    this.router.navigateByUrl(route);
  }
}
